import axios from "axios";
import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const apiUrl = window.APP_CONFIG.api1.baseapi;

const LoginService = {
  login: async (payload) => {
    console.log(payload);
    const response = await apiService.post("/users/login", payload);
    console.log(response.data);
    return response.data;
  },

  register: async (payload) => {
    const response = await apiService.post("/users/register-user", payload);
    return response.data;
  },
  forgetpassword: async (email) => {
    const response = await axios.post(`${apiUrl}/users/forget-password`, null, {
      params: {
        useremail: email,
      },
    });
    return response.data;
  },

  resetpassword: async (usernameOrEmail, Otp, newPassword) => {
    const response = await apiService.post(
      "/users/reset-forget-password",
      null,
      {
        params: {
          usernameOrEmail,
          Otp,
          newPassword,
        },
      },
    );

    return response.data;
  },
  updatePassword: async (payload) => {
    // payload: { oldPassword, newPassword, confirmPassword }
    const response = await apiService.post("/users/change-password", payload);
    return response.data;
  },
};

export default LoginService;
